export default __webpack_public_path__ + "static/media/Logo.e331e73f.png";